(function() {
  function initExteriorMulticapa(root) {
    if (!root || root.dataset.exteriorMulticapaInitialized === 'true') return;

    root.dataset.exteriorMulticapaInitialized = 'true';

    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-layer-button]'));
    var layers = Array.prototype.slice.call(root.querySelectorAll('[data-layer]'));

    if (!buttons.length || !layers.length) return;

    var activeLayer = root.getAttribute('data-active-layer') || 'aluminium';
    var activeButton = null;
    var hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
    var mobileQuery = window.matchMedia('(max-width: 749px)');

    function canHover() {
      return hoverQuery.matches;
    }

    function isMobile() {
      return mobileQuery.matches;
    }

    function getCardText(button) {
      return button ? button.querySelector('.exterior-multicapa__card-text') : null;
    }

    function clearCardHeights() {
      buttons.forEach(function(button) {
        var text = getCardText(button);

        if (text) {
          text.style.height = '';
        }
      });
    }

    function closeMobileCardInstant(button) {
      if (!button || !isMobile()) return;

      button.classList.add('is-closing-instant');

      var text = getCardText(button);

      if (text) {
        text.style.height = '';
      }

      button.offsetHeight;

      window.requestAnimationFrame(function() {
        button.classList.remove('is-closing-instant');
      });
    }

    function closeCard(button) {
      var text = getCardText(button);
      if (!text) return;

      if (isMobile()) {
        text.style.height = '';
        return;
      }

      if (text.style.height === 'auto') {
        text.style.height = text.scrollHeight + 'px';
        text.offsetHeight;
      }

      text.style.height = '0px';
    }

    function openCard(button) {
      var text = getCardText(button);
      if (!text) return;

      if (isMobile()) {
        text.style.height = '';
        return;
      }

      if (text._emcTransitionEnd) {
        text.removeEventListener('transitionend', text._emcTransitionEnd);
        text._emcTransitionEnd = null;
      }

      text.style.height = '0px';
      text.offsetHeight;

      text.style.height = text.scrollHeight + 'px';

      text._emcTransitionEnd = function(event) {
        if (event.propertyName !== 'height') return;

        text.removeEventListener('transitionend', text._emcTransitionEnd);
        text._emcTransitionEnd = null;

        if (button.classList.contains('is-active')) {
          text.style.height = 'auto';
        }
      };

      text.addEventListener('transitionend', text._emcTransitionEnd);
    }

    function setInitialCardHeights() {
      buttons.forEach(function(button) {
        var text = getCardText(button);
        var isActive = button.getAttribute('data-layer-button') === activeLayer;

        if (!text) return;

        if (isMobile()) {
          text.style.height = '';
        } else {
          text.style.height = isActive ? 'auto' : '0px';
        }

        if (isActive) {
          activeButton = button;
        }
      });
    }

    function showLayer(layerName) {
      layers.forEach(function(layer) {
        layer.classList.toggle(
          'is-active',
          layer.getAttribute('data-layer') === layerName
        );
      });
    }

    function setActiveButton(layerName, animateCard) {
      var previousButton = activeButton;
      var nextButton = null;

      if (isMobile() && previousButton && previousButton.getAttribute('data-layer-button') !== layerName) {
        closeMobileCardInstant(previousButton);
      }

      buttons.forEach(function(button) {
        var isActive = button.getAttribute('data-layer-button') === layerName;

        button.classList.toggle('is-active', isActive);
        button.classList.remove('is-preview');
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');

        if (isActive) {
          nextButton = button;
        }
      });

      activeButton = nextButton;

      if (isMobile()) {
        clearCardHeights();
        return;
      }

      if (!animateCard) {
        setInitialCardHeights();
        return;
      }

      if (previousButton && previousButton !== nextButton) {
        closeCard(previousButton);
      }

      if (nextButton && previousButton !== nextButton) {
        openCard(nextButton);
      }
    }

    function clearPreview() {
      buttons.forEach(function(button) {
        button.classList.remove('is-preview');
      });
    }

    function activateLayer(layerName) {
      if (!layerName || layerName === activeLayer) return;

      activeLayer = layerName;
      root.setAttribute('data-active-layer', layerName);

      showLayer(layerName);
      setActiveButton(layerName, true);
    }

    function previewLayer(layerName, button) {
      if (!canHover() || !layerName) return;

      showLayer(layerName);
      clearPreview();

      if (button && layerName !== activeLayer) {
        button.classList.add('is-preview');
      }
    }

    function syncAfterResize() {
      var currentActiveButton = null;

      buttons.forEach(function(button) {
        var text = getCardText(button);
        var isActive = button.classList.contains('is-active');

        if (isActive) {
          currentActiveButton = button;
        }

        if (!text) return;

        if (isMobile()) {
          text.style.height = '';
        } else {
          text.style.height = isActive ? 'auto' : '0px';
        }
      });

      activeButton = currentActiveButton;
    }

    buttons.forEach(function(button) {
      button.addEventListener('click', function(event) {
        event.preventDefault();

        var layerName = button.getAttribute('data-layer-button');

        if (layerName) {
          activateLayer(layerName);
        }
      });

      button.addEventListener('pointerenter', function(event) {
        if (event.pointerType !== 'mouse') return;

        var layerName = button.getAttribute('data-layer-button');
        previewLayer(layerName, button);
      });

      button.addEventListener('focus', function() {
        if (!canHover()) return;

        var layerName = button.getAttribute('data-layer-button');
        previewLayer(layerName, button);
      });
    });

    root.addEventListener('mouseleave', function() {
      if (!canHover()) return;

      showLayer(activeLayer);
      clearPreview();
    });

    showLayer(activeLayer);
    setActiveButton(activeLayer, false);

    window.addEventListener('resize', syncAfterResize);

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', syncAfterResize);
    } else if (mobileQuery.addListener) {
      mobileQuery.addListener(syncAfterResize);
    }
  }

  function initAllExteriorMulticapa() {
    var roots = document.querySelectorAll('.js-exterior-multicapa');

    roots.forEach(function(root) {
      initExteriorMulticapa(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllExteriorMulticapa);
  } else {
    initAllExteriorMulticapa();
  }

  document.addEventListener('shopify:section:load', function(event) {
    var root = event.target.querySelector('.js-exterior-multicapa');

    if (root) {
      root.dataset.exteriorMulticapaInitialized = 'false';
      initExteriorMulticapa(root);
    }
  });
})();